import React, {PureComponent} from "react"
import styled from "styled-components"

import ProfilePic from "@irati/ui/src/ProfilePicture"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {User} from "@irati/types"
import {IconButton, IconTypes} from "@irati/ui/src/Button"
import {Body} from "@irati/ui/src/Typography"
import id from "@irati/utils/id"

interface Props {
  removeUser(user: User): void
  user: User
  index: number
}

const FlexRow = styled.div`
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
  margin-bottom: ${({theme}) => theme.spacing.one};
  padding-bottom: 10px;
  align-items: center;
  display: flex;
  justify-content: space-between;
`

const StyledProfilePic = styled(ProfilePic)`
  margin-right: 10px;
`

const StyledUser = styled.div`
  width: calc(100% - 90px);
`

const StyledButton = styled(IconButton)`
  width: 20px;
`

class SelectedUser extends PureComponent<Props> {
  static defaultProps = {
    id: "rewardRecipientsList"
  }

  render() {
    const {removeUser, user, index} = this.props

    return (
      <FlexRow id={id(`recipient${index}`, this.props)} key={user.uuid}>
        <StyledProfilePic user={user} regular />
        <StyledUser>
          <Body large maxWidth="100%" marginBottom={1}>
            {firstnameLastname(user)}
          </Body>
        </StyledUser>
        <StyledButton icon={IconTypes.cross} onClick={() => removeUser(user)} />
      </FlexRow>
    )
  }
}

export default SelectedUser
